
export const getTypeName = (value: any) => {
	const match = Object.prototype.toString.apply(value).match(/\[\w+\s(.*)\]/)
	return (match && match[1]) || 'Object'
}